import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REHYDRATE } from 'redux-persist';
import { axiosBaseQuery } from './baseQuery';

const PRESIGNED_URL = `/s3/presignedUrl`;

export const uploadS3Api = createApi({
  reducerPath: 'upload.api',
  baseQuery: axiosBaseQuery,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === REHYDRATE) {
      return action.payload?.[reducerPath];
    }
  },
  tagTypes: ['upload'],
  endpoints: (builder) => ({
    getPresignedUrl: builder.query({
      query: (fileName: string) => ({ url: `${PRESIGNED_URL}?fileName=${encodeURI(fileName)}` }),
      transformResponse: (response: { draftFileUrl: string; presignedUrl: string }) => {
        return {
          draftFileUrl: response.draftFileUrl,
          presignedUrl: response.presignedUrl,
        };
      },
      providesTags: ['upload'],
    }),
  }),
});

export const { useLazyGetPresignedUrlQuery } = uploadS3Api;
